export default "__VITE_ASSET__BLkqP15R__"